import { InjectionToken } from '@angular/core';
import { ErrorMessage } from '../Models/ErrorMessage';

export const /** @type {?} */ CUSTOM_ERROR_MESSAGES = new InjectionToken<ErrorMessage[]>(
  "ng-bootstrap-form-validation custom error messages"
);



// WEBPACK FOOTER //
// ~/ng-bootstrap-form-validation/ng-bootstrap-form-validation/src/lib/Tokens/tokens.ts